// could take a space id or space name and returns the space name in all caps
export function getSpaceNameCaps(space: string) {
  const spaceLower = space?.toLowerCase()

  if (spaceLower == "citn2sn5tdjr" || spaceLower == "corporate") {
    return "CORPORATE"
  } else if (spaceLower == "u6dt4dql5puc" || spaceLower == "construction") {
    return "CONSTRUCTION"
  } else if (spaceLower == "1nvkn1423yot" || spaceLower == "geospatial") {
    return "GEOSPATIAL"
  } else if (spaceLower == "9k5dj5b59lqq" || spaceLower == "autonomy") {
    return "AUTONOMY"
  } else if (spaceLower == "f1e2584ztjpk" || spaceLower == "staging") {
    return "STAGING"
  } else if (spaceLower == "5qimfmsew7zl" || spaceLower == "sketchup") {
    return "SKETCHUP"
  } else if (spaceLower == "rerp0bq2ntu3" || spaceLower == "marketplace") {
    return "MARKETPLACE"
  } else if (spaceLower == "0hyoy390926j" || spaceLower == "datastorage") {
    return "DATASTORAGE"
  } else if (spaceLower == "jnzexz4x7lkk" || spaceLower == "resourcecenter") {
    return "RESOURCECENTER"
  }
  return null
}
